import { render, staticRenderFns } from "./SubscriptionView.vue?vue&type=template&id=be8efd5a&scoped=true"
import script from "./SubscriptionView.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SubscriptionView.vue?vue&type=style&index=0&id=be8efd5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8efd5a",
  null
  
)

export default component.exports